import { LABEL_MISSING } from '../enums';

export const appLabels = window.competition_setup.app_labels || {
  email: 'Email',
  emailRequired: 'Email required',
  emailNotValid: 'Not a valid email',
  password: 'Password',
  passwordRequired: 'Password required',
  requiredField: 'Required field',
  select: 'Select',
  yes: 'Yes',
  no: 'No',
  loggedInAs: 'Logged in as',
  loginTitle: 'Login',
  loginWrongUserNamePassword: 'Wrong username/password',
  loginButton: 'Login',
  registerTitle: 'Register',
  registerFirstName: 'First name',
  registerLastName: 'Last name',
  registerCountry: 'Country or Region of residence',
  registerNationality: 'Nationality/Regional Citizenship',
  registerSelectCountry: 'Select country',
  registerSelectNationality: 'Select nationality',
  registerConfirmEmail: 'Confirm email',
  registerConfirmPassword: 'Confirm password',
  registerNewsletter: 'Sign up to newsletter',
  registerThirdParty: 'Allow third party',
  registerTandC: 'Tick the box to say you agree to the terms and conditions',
  registerTandCRequired: 'Please accept the terms and conditions',
  registerButton: 'Join',
  registerFirstNameRequired: 'First name required',
  registerLastNameRequired: 'Last name required',
  registerCountryRequired: 'Country required',
  registerNationalityRequired: 'Nationality required',
  registerEmailsMustMatch: 'Emails must match',
  registerPasswordsMustMatch: 'Passwords must match',
  registerPasswordRules: 'Password must be 8 characters minimum and contain at least one uppercase letter, lowercase letter, number and symbol',
  registerPasswordMinEight: 'Password must be at least 8 characters',
  categorySelectTab: 'Category selection',
  categorySelectTitle: 'Category selection',
  categorySelectButton: 'Select',
  entryUploadTab: 'Entry upload',
  entrySubmitTab: 'Entry submit',
  entrySubmitTitle: 'Entry submit',
  entryName: 'Film title',
  entryVideo: 'Video URL',
  entryDescription: 'Film Description (150 words max)',
  entryThumbnail: 'Thumbnail',
  entryImageDrop: 'Drop an image here or click to select an image',
  entryChangeCategory: 'Change category',
  entryButton: 'Submit',
  entryNameRequired: 'Name required',
  entryValidUrlRequired: 'Valid URL required',
  entryVideoRequired: 'Video URL required',
  entryDescriptionRequired: 'Description required',
  entryThumbnailRequired: 'Thumbnail required',
  entryThumbnailSize: 'File size or filename size exceeded. Max image size is 5120KB, minimum image size is 1000KB, max file name length is 200',
  'min-size': 'Minimum image file size accepted: 1MB',
  entryUploadTitle: 'Entry upload',
  entryInstitution: 'Institution required',
  noCategoriesFound: 'No categories found or the competition has closed',
  entryProcessing: 'We are processing your entry. Please wait.',
  entrySubmitted: 'Thank you for submitting your entry.',
  backToCompetition: 'Back to competition',
  profileTitle: 'Title',
  profileTelephone: 'Telephone (including country code)',
  profileDob: 'Date of birth',
  profileScreenTitle: 'Profile',
  myEntriesTitle: 'My Entries',
  overviewLabelCompetition: 'Competition',
  overviewLabelCategory: 'Category',
  overviewLabelDate: 'Closing date',
  overviewLabelId: 'Entry ID',
  overviewLabelStatus: 'Entry status',
  overviewActions: 'Actions',
  overviewViewEntry: 'View entry',
  menuEntries: 'My entries',
  menuProfile: 'Profile',
  menuCategories: 'Categories',
  menuLogout: 'Logout',
  saveProfileButton: 'Save profile',
  profileUpdateProcessing: 'Updating profile',
  profileUpdated: 'Profile updated',
  profileValidPhoneNumber: 'Phone number must be valid and a include country code',
  viewEntryTitle: 'View entry',
  viewEntryVideoUrl: 'Video URL',
  viewEntryBack: 'Back to my entries',
  'validation.starts_with': 'The phone number must start with a +.',
  'validation.image_limit': 'You have added too many images to this competition category.',
  'validation.competition_open': 'This Competition is not currently open for image submission.',
  'validation.has_allowance': 'Your account doesn\'t have the required allowance to submit all of these images at this time. Please either delete some of the images or click on \'Image Bundles\' in the menu above..',
  'validation.enough_images': 'Not enough images for Entry.',
  'validation.once_per_profile': 'You cannot enter more than one series into this category.',
  'validation.not_entered_linked_competition': 'You are unable to enter this competition, due to already entering another competition this year.',
  'validation.wpoimage': 'Image uploads are limited too the following file extensions: jpg jpeg png.',
  'validation.toolarge': 'The combined size of the file(s) you tried to upload was to large. Please upload them in smaller batches.',
  'validation.profile_complete': 'We require you to complete your profile before you submit your entry.',
  'validation.windows_filename': 'File names must not contain / : ? " < > | *',
  'validation.filename': 'File names including their extension cannot be longer than 200 characters',
  'validation.oneuppercaseletter': 'Password must contain at least one uppercase letter.',
  'validation.onenumber': 'Password must contain at least one number.',
  'validation.onelowercaseletter':  'Password must contain at least one lowercase letter.',
  'validation.wpo_password':  'Password cannot contain your forename, surname, or email address.',
  'validation.onesymbol': 'Your password must contain one of the following symbols; !, £, $, %, ^, &, *, (, ), @, #, ~',
  'validation.historic_password': 'You cannot use a password you have previously used with your account.',
  'validation.confirm_original_password': 'Your current password confirmation doesn\'t match.',
  'validation.simular_to_password': 'Your new password is too simular to your current password.',
  'institutionLabel': 'Institution. Use the text search to find your institution or select "Other" if its not in the list. Enter 4 characters minimum to start the search.',
  'institutionsNotFound': 'No institutions found',
  'imageDropZone': 'Image file extensions accepted: jpg jpeg png. Minimum image file size accepted: 1MB - Maximum image file size accepted: 5MB',
  'entrySubmittedStatus': 'Submitted',
  entryVideoService: 'Videos should be hosted on Vimeo or YouTube.',
  entryMake: 'Camera brand',
  entryModel: 'Camera model',
  "entryMakeRequired": "Camera brand is required",
  "entryModelRequired": "Camera model is required",
  entryVideoHelpText: 'YouTube videos should have the URL pattern of https://www.youtube.com/watch?v=XXXXXXXX. Vimeo videos should have the URL pattern of https://vimeo.com/XXXXXXXX',
  'entryUsingAi': 'As specified in section 4.1.9 of the competition rules, please confirm if AI assisted in creating any elements in this film.',
  'entryUsingAiDetails': 'Please include additional details on how AI was used and corresponding timestamps.',
  'entryAiDetailsRequired': 'Additional details required',
  'entryUsingAiRequired': 'AI assisted required',
  "entryOtherMake": "Other Camera Brand",
  "entryMakeOther": "Other",
  "entryMakeSmartphone": "Smartphone",
  "courseName": "Course name",
  "tutorsName": "Tutors name",
  "tutorsEmail": "Tutors email (please ensure you have permission to provide this information)",
  "institutionPlaceholder": "Enter 4 characters minimum to start the search",
  "maxLength150": "Max length 150 words",
  "filmPassword": "Film password (If Applicable)",
  "schoolCountry": "School country",
  "bio": "Filmmaker Bio (150 words max)",
  "institutionNotFoundLabel": "Please enter the name of the institution",
  "other-mobile-phone": "Other mobile phone",
  "creo-policy": "I agree to Creo's ",
  "creo-privacy-policy": "privacy policy",
  "fileUrl": "File URL. Provide a downloadable link to your film via Google Drive, WeTransfer, or a similar service.",
  "fileUrlBlocked": "This domain cannot be used for the Video Url field"
}

export const getLabel = (labelKey) => {
  return appLabels[labelKey] || LABEL_MISSING;
}